module.exports = __webpack_public_path__ + "media/svg/interviews-selected-83e0b6ae.svg";